/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FastCrawlLoader_flowState = {
    readonly id: string;
    readonly flowKey: string | null;
    readonly current: {
        readonly state: string | null;
        readonly percentComplete: number | null;
        readonly errorMessage: string | null;
    } | null;
    readonly pending: {
        readonly state: string | null;
        readonly percentComplete: number | null;
        readonly errorMessage: string | null;
    } | null;
    readonly " $refType": "FastCrawlLoader_flowState";
};
export type FastCrawlLoader_flowState$data = FastCrawlLoader_flowState;
export type FastCrawlLoader_flowState$key = {
    readonly " $data"?: FastCrawlLoader_flowState$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FastCrawlLoader_flowState">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "FastCrawlLoader_flowState",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flowKey",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStatus",
                "kind": "LinkedField",
                "name": "current",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStatus",
                "kind": "LinkedField",
                "name": "pending",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            }
        ],
        "type": "FlowState",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '71033616226c69912f668f83dbb7aaba';
export default node;
